const privateTheaterData = [
  {
    title: "Couple Movie Experiences",
    image: "/Assets/couple_movie_experiences.webp",
    price: 1999,
    rating: 4,
  },
  {
    title: "Couple Romantic Show with Celebration",
    image: "/Assets/Couple Romantic Show with Celebration.png",
    price: 3999,
    rating: 4,
  },
  {
    title: "Private Theatre Megha Show Birthday",
    image: "/Assets/Private Theatre Megha Show Birthday.png",
    price: 5999,
    rating: 4,
  },
  {
    title: "Surprise Celebration and Super Show",
    image: "/Assets/Surprise Celebration and Super Show.jpeg",
    price: 7999,
    rating: 4,
  },
  {
    title: "Friends and Family Show",
    image: "/Assets/friends_and_family_shows.webp",
    price: 1999,
    rating: 4,
  },
  {
    title: "Personalized Video Shows",
    image: "/Assets/Personalized Video Shows.jpg",
    price: 3999,
    rating: 4,
  },
  {
    title: "Live-Streamed or Recorded Shows",
    image: "/Assets/Live-Streamed or Recorded Shows.jpg",
    price: 5999,
    rating: 4,
  },
  {
    title: "Special Entertainment Screenings",
    image: "/Assets/Special Entertainment Screenings.jpg",
    price: 7999,
    rating: 4,
  }
];

export default privateTheaterData;
